import { refreshAccessToken } from '@notes/webintegrations-common'
import { AuthMethod, IAuthContext } from '../../shared/auth/IAuthContext'

export class OAuthContext implements IAuthContext {
  private accessToken: string

  constructor (initialToken: string) {
    this.accessToken = initialToken
  }

  getAccessToken(): string {
    return this.accessToken
  }

  getSubstrateNotesToken(): string | undefined {
    return undefined
  }

  async refresh(): Promise<void> {
    const oAuthToken = await refreshAccessToken()
    this.accessToken = oAuthToken.access_token
  }

  getAuthMethod(): AuthMethod {
    return AuthMethod.OAuth
  }
}
